// extracted by mini-css-extract-plugin
export var colorSquare = "_o4-0";
export var danger = "_o4-5";
export var lightPink = "_o4-8";
export var neutralBlue = "_o4-7";
export var neutralYellow = "_o4-6";
export var normal = "_o4-1";
export var primary = "_o4-2";
export var primaryLight = "_o4-3";
export var solidBlack = "_o4-g";
export var solidGreen = "_o4-b";
export var solidLightBlue = "_o4-d";
export var solidNavy = "_o4-c";
export var solidOrange = "_o4-f";
export var solidPink = "_o4-e";
export var solidRed = "_o4-9";
export var solidYellow = "_o4-a";
export var success = "_o4-4";